<template>
  <div style="margin-top:20px;">
    <Table
      :data="tableData"
      :columns="columns"
      stripe
      ref="table"
      :height="370"
      style="width: 100%"
      no-data-text="<div class='table-no-data'></div>"
    >
    </Table>
    <div id="mypage">
      <div>
        <Page
          :current="1"
          :total="total"
          :page-size="pageSize"
          :page-size-opts="[50, 100, 200, 500, 1000]"
          show-total
          show-elevator
          show-sizer
          @on-change="changePage"
          @on-page-size-change="pageSizeChange"
        ></Page>
      </div>
    </div>
  </div>
</template>
<script>
var store = [];
export default {
  data() {
    return {
      openTable: false,
      columns: [
        {
          type: "index",
          minWidth: 60,
          maxWidth: 100,
          align: "center",
        },
        {
          title: "车牌号",
          key: "carNo",
          minWidth: 130,
          maxWidth: 200,
        },

        {
          title: "定位时间",
          key: "gpsTime2",
          minWidth: 130,
          maxWidth: 200,
        },
        {
          title: "一路温度",
          key: "one",
          minWidth: 130,
          maxWidth: 200,
        },
        {
          title: "二路温度",
          key: "two",
          minWidth: 130,
          maxWidth: 200,
        },
        {
          title: "三路温度",
          key: "three",
          minWidth: 100,
          maxWidth: 200,
        },
        {
          title: "四路温度",
          key: "four",
          minWidth: 100,
          maxWidth: 200,
        },

        {
          title: "发动机",
          key: "accStatus",
          minWidth: 100,
          maxWidth: 200,
          render: (h, data) => {
            var status = {
              0: { name: "关", color: "ly-gray" },
              1: { name: "开", color: "ly-green" },
            };
            return h(
              "div",
              { class: status[data.row.accStatus].color },
              status[data.row.accStatus].name
            );
          },
        },
        {
          title: "速度",
          key: "speed",
          minWidth: 100,
          maxWidth: 200,
        },
        {
          title: "里程",
          key: "mileage",
          minWidth: 100,
          maxWidth: 200,
        },
        {
          title: "事件",
          key: "eventDesc",
          minWidth: 100,
          maxWidth: 200,
        },
        {
          title: "设备号",
          key: "deviceNo",
          minWidth: 130,
          maxWidth: 200,
        } /* ,
        {
          title: "波动标识",
          key: "carStatus",
          minWidth: 100,
          maxWidth: 200,
          render: (h, data) => {
            var status = {
              0: { name: "正常", color: "ly-green" },
              1: { name: "加油", color: "ly-red" },
              2: { name: "放油", color: "ly-yellow" },
            };
            return h(
              "div",
              { class: status[data.row.ocFlag].color },
              status[data.row.ocFlag].name
            );
          },
        },
        {
          title: "电阻波动",
          key: "ocOil",
          minWidth: 100,
          maxWidth: 200,
        },
        {
          title: "油量波动",
          key: "ocOilVolume",
          minWidth: 100,
          maxWidth: 200,
        },
        {
          title: "波动百分比",
          key: "ocOilRatio",
          minWidth: 100,
          maxWidth: 200,
        }, */,
      ],
      tableData: [],
      pageNumber: 1,
      pageSize: 500,
      total: 0,
    };
  },
  methods: {
    reachData(data) {
      store = data.reverse();
      this.total = data.length;
      this.tableData = this.utils.page(this.pageNumber, this.pageSize, store);
    },
    open() {
      this.openTable = true;

    },
    //页码切换时触发
    changePage(x) {
      this.pageNumber = x;
      this.tableData = this.utils.page(this.pageNumber, this.pageSize, store);
    },
    //每页总条数切换
    pageSizeChange(x) {
      this.pageSize = x;
      this.tableData = this.utils.page(this.pageNumber, this.pageSize, store);
    },
  },
};
</script>


// WEBPACK FOOTER //
// ../common/src/components/temp/tempList.vue